import React, { Component } from 'react';
import PropTypes from 'prop-types';
import range from 'lodash/range';
import './styles.css';

class StepperBar extends Component {
	render() {
		const { submissions, submissionActive } = this.props;
		const widthStyle = { width: `${100 / (submissions-1)}%` };
		return (
			<div className="submission-stepper-bar">
				{range(1, submissions).map(
					n =>
						submissionActive > n ?
							<div
								key={n}
								className="submission-stepper-bar-item submission-stepper-bar-item-full"
								style={widthStyle}
							/>
							:
							<div
								key={n}
								className="submission-stepper-bar-item submission-stepper-bar-item-empty"
								style={widthStyle}
							/>

				)}
			</div>
		);
	}
}

StepperBar.propTypes = {
	submissions: PropTypes.number,
	submissionActive: PropTypes.number
};

export default StepperBar;
